import styled from 'styled-components/macro'
import { Link } from 'react-router-dom';
import closeImg from './../../../../assets/close.png'
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

const MenuContainer = styled.div`
  position: fixed;
  top: 80px;
  right: 0;
  width: 250px;
  background: #fff;
  z-index: 1000;
  padding: 30px 0 25px;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  border-radius: 10px 0 0 10px;
  font-family: Palatino Linotype;
  text-transform: uppercase;
`;

const Wrapper = styled.div`
  padding: 0 40px 0 65px;
  display: flex;
  flex-direction: column;
`;


const MenuHeader = styled(Link)`
  margin-bottom: 20px;
  font-size: 14px;
  color: #333;
  font-weight: 700;
`;

// const MenuLink = styled(Link)`
//   margin-bottom: 20px;
//   font-size: 14px;
//   color: #333;
//   text-decoration: none;

//   &:hover {
//     color: #007bff;
//   }
// `;

const MenuLink = styled(Link)`
  margin-bottom: 20px;
  font-size: 14px;
  color: #333;
  text-decoration: none;
  font-weight: ${({ $active }) => ($active ? '700' : '400')};

  &:hover {
    color: #007bff;
  }
`;

const Header = styled.div`
    padding: 0 30px;
    margin-bottom: 17px;
`;

const Close = styled.img`
    width: 12px;
    cursor: pointer;
`;



const BurgerMenu = ({ isOpen, onClose }) => {
  const { t } = useTranslation()
  const location = useLocation();
    
  return (
    <>
      <Backdrop isOpen={isOpen} onClick={onClose} />
      <MenuContainer isOpen={isOpen}>
        <Header>
            <Close alt='close' src={closeImg} onClick={onClose}/>
        </Header>
        <Wrapper>
            <MenuLink to="/" onClick={onClose} $active={location.pathname === '/'}>{t('Main')}</MenuLink>
            <MenuLink to="/cathegory" onClick={onClose} $active={location.pathname === '/cathegory'}>{t('cathegory_menu')}</MenuLink>
            <MenuLink to="/masters" onClick={onClose} $active={location.pathname === '/masters'}>{t('masters')}</MenuLink>
            <MenuLink to="/masterclass" onClick={onClose} $active={location.pathname === '/masterclass'}>{t('pics')}</MenuLink>
            <MenuLink to="/patterns" onClick={onClose} $active={location.pathname === '/patterns'}>{t('patterns')}</MenuLink>
            <MenuLink to="/show" onClick={onClose} $active={location.pathname === '/show'}>{t('show')}</MenuLink>
            <MenuLink to="/news" onClick={onClose} $active={location.pathname === '/news'}>{t('news')}</MenuLink>
        </Wrapper>
      </MenuContainer>
    </>
  );
};

export default BurgerMenu;